<script lang="ts">
	import PhotoGallery from '$lib/modules/PhotoGallery.svelte';
	import type { OperationModel } from '../../../models/api/OperationModel';
	import { t } from 'svelte-i18n';
	import { capitalize } from '$lib/utils/strings';
	import { getEmbedVideoUrl } from '../../../utils/videos';
	import AdaptiveVideo from '$lib/modules/AdaptiveVideo.svelte';

	export let operation: OperationModel;

	$: hasVideo = operation.idVideoEmbed !== undefined && operation.typeVideoEmbed !== undefined;
</script>

{#if (operation.images && operation.images.length) || hasVideo}
	<section>
		<h2>{capitalize($t('operation.photoGallery'))}</h2>
		{#if operation.images && operation.images.length && hasVideo}
			<PhotoGallery
				photosUrls={operation.images}
				typeVideoEmbed={operation.typeVideoEmbed}
				idVideoEmbed={operation.idVideoEmbed}
			/>
		{/if}
		{#if operation.images && operation.images.length && !hasVideo}
			<PhotoGallery photosUrls={operation.images} />
		{/if}
		{#if !operation.images && hasVideo}
			<AdaptiveVideo
				src={getEmbedVideoUrl(operation.idVideoEmbed, operation.typeVideoEmbed)}
				iframeTitle={$t('operation.videoTitle')}
				ratio="aspect-video"
				iframe={true}
			/>
		{/if}
	</section>
{/if}
